import { ChangeEvent, useEffect, useMemo, useRef, useState } from "react"
import LoaderComp from "../../loader/Loader"
import { MaterialReactTable, MRT_ColumnDef, useMaterialReactTable } from "material-react-table";
import { Link } from "react-router-dom";
import { useCVPageContext } from "../../context/cvPageContext";

function SemanticResults(props:any) {
    const [semanticResults, setSemanticResults] = useState([]);
    const [timeElapsed, setTimeElapsed] = useState(false);
    const{
          codFiscP,
          setCodFiscP,
          setIsAIP,
          setUrlPDFP,
          setTimeCvsP,
          } = useCVPageContext();

    interface Semantic {
        Candidate_id: string;
        City: string;
        CV_red: string;
        Ole_profile: string;
      }

    const columns = useMemo<MRT_ColumnDef<Semantic>[]>(
        () => [
          {
            accessorKey: 'Candidate_id',
            header: 'ID Candidato',
          },
          {
            accessorKey: 'City',
            header: 'Città',
          },
          {
            accessorKey: 'CV_red',
            header: 'CV',
          },
          {
            accessorKey: 'Ole_profile',
            header: 'Profilo Ole',
          }
        ],
        []
    )

    const data: Semantic[] = semanticResults

    const table = useMaterialReactTable({
        columns,
        data,
        initialState: { density: 'compact' },
        enableStickyHeader: true,
        muiTableContainerProps: {sx: { maxHeight: '500px' } },
        columnResizeMode: 'onEnd',
        layoutMode: 'grid',
        enableColumnResizing: true,
        enableRowActions: true,
        localization: {'actions':'Suggerimento'},
        positionActionsColumn: 'last',
        renderRowActions: ({ row }) => (
          <div>
            <Link to={`/cv?context=${encodeURIComponent(row.original.Candidate_id)}`} target="_blank" onClick={() => sendCodFisc(row.original.Candidate_id)}> <button className="cta-red-test">{"CV Candidato"}</button></Link>
          </div>
      ),
        });

    const sendCodFisc = (fiscale:any) => {
      setCodFiscP("");
      setUrlPDFP("");
      setIsAIP(false);
      setTimeCvsP(false);
      setCodFiscP(fiscale);
    }

    const getBack = () => {
        setSemanticResults([]);
        props.setIsResult(false);
    }

    const handleVectorResults = (dataPost:any) => {

        fetch(`/api/realtime/search_profile`, {
            method: 'POST',
            headers: { 'Accept': 'application/json',
                      "Content-Type": "application/json"},
            body: JSON.stringify(dataPost)})
            .then(response => response.json())
            .then(function(data){ 
            setSemanticResults(data)
            if (data.length === 0) {
                setTimeElapsed(true)
            }})

          console.log(semanticResults)
    }

    useEffect(() => {
        if (semanticResults.length === 0) {
          handleVectorResults(props.dataPost);
        }
      }, [])

    return (
        <div className="containerTest">
            <div className='home-btn-slot-5'>
              <i className='bx bx-home bx-sm bx-border' id='home-btn' onClick={getBack}>
                <span className='home-btn-text-5'>
                  Torna alla schermata Home
                </span>
              </i>
            </div>
            {(semanticResults.length > 0 || timeElapsed)
            ?
              <div className="back">
                  <MaterialReactTable table={table}/>
              </div>
            :
              <div className="div-center">
                  <div>
                      <h3> Caricamento risultati semantic</h3>
                  </div>
                  <div style={{width:"100px", margin:"auto"}}>
                      <LoaderComp></LoaderComp>
                  </div >
              </div>
            }
        </div>
    )
}

export default SemanticResults

